import { service } from "@/common/axios-service";
import axios from "axios";
import { setMetricaUser } from "@/common/metrica-helper";

let refreshTokenPromise = null;
let authGeneration = 0;

const state = {
    user: null,
}

const getters={
    isAuthenticated: (state) => !!state.user,
    StateUser: (state) => state.user,
    NameSurname : (state) => {
      if(state.user && state.user.nameSurname){
        return state.user.nameSurname
      }else{
        return '';
      }
    },
    isDemoCreate : (state) => {
      if(state.user && state.user.isDemoCreate){
        return state.user.isDemoCreate
      }else{
        return false;
      }
    }
}

const actions ={
  async RefreshToken({ commit, getters }) {
    if (!refreshTokenPromise) {
      refreshTokenPromise = (async () => {
        const requestGeneration = authGeneration;
        const user = getters["StateUser"];
        if (!user || !user.refreshToken) throw new Error("No refresh token");

        const res = await axios.create({
          baseURL: process.env.VUE_APP_ROOT_API,
          timeout: 60000
        }).post('Login/RefreshToken', { PanelType: 2, RefreshToken: user.refreshToken });

        if (requestGeneration !== authGeneration)
          throw new Error("Authentication state changed during token refresh");

        commit("setUser", res.data);
        return res.data.token;
      })().finally(() => {
        refreshTokenPromise = null;
      });
    }

    return refreshTokenPromise;
  },
  async Register({ dispatch }, form) {
    await service.post('register', form)
    let UserForm = new FormData()
    UserForm.append('username', form.username)
    UserForm.append('password', form.password)
    await dispatch('LogIn', UserForm)
  },

  async LogIn({ commit }, user) {
    return new Promise((resolve,reject)=>{
      service.post("Login/AccessToken", user)
      .then((res) => {
        if(res && res.data)
        {
          authGeneration++;
          commit("setUser", res.data);
          resolve();
        }
        else
          reject({message:''});
        
      })
      .catch(err => {
        reject(err);
      });
    });
  },

  // async CreatePost({ dispatch }, post) {
  //   await service.post("post", post);
  //   return await dispatch("GetPosts");
  // },

  // async GetPosts({ commit }) {
  //   let response = await service.get("posts");
  //   commit("setPosts", response.data);
  // },

  async LogOut({ commit }, revokeSession = true) {
    authGeneration++;
    if (window.globalTimer) {
      clearInterval(window.globalTimer);
      window.globalTimer = null;
    }
    if (revokeSession && state.user) {
      try {
        await service.post("Login/Logout", {});
      } catch {
        // Local logout must complete even when the API is unavailable.
      }
    }
    refreshTokenPromise = null;
    commit("logout", null);
  },

  async ForgotPassword(context,form) {
    return new Promise((resolve,reject)=>{
      service.post("Login/ForgotPassword", form)
      .then((res) => {
        if(res && res.data)
          resolve(res.data);
        else
          reject({message:''});
      })
      .catch(err => {
        reject(err);
      });
    });
  },
  async SavePassword(context,form) {
    return new Promise((resolve,reject)=>{
      service.post("Login/SavePassword", form)
      .then((res) => {
        if(res && res.data)
          resolve(res.data);
        else
          reject({message:''});
      })
      .catch(err => {
        reject(err);
      });
    });
  },
  async StudentPanelRegisterAsync(context,form) {
    return new Promise((resolve,reject)=>{
      service.post("Form/StudentPanelRegister", form)
      .then((res) => {
        if(res && res.data)
          resolve(res.data);
        else
          reject({message:''});
      })
      .catch(err => {
        reject(err);
      });
    });
  },
  

}

const mutations ={
      setUser(state, user) {
        state.user = user;
        if (user) {
          const userId = user.userId || user.id || user.UserId;
          setMetricaUser(userId);
        }
      },
      // setPosts(state, posts) {
      //   state.posts = posts;
      // },
      logout(state, user) {
        state.user = user;
        setMetricaUser(null);
      },
}

export default{
    state,
    getters,
    actions,
    mutations
};
